"use strict";
'use es6';

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));

var _taggedTemplateLiteralLoose2 = _interopRequireDefault(require("@babel/runtime/helpers/taggedTemplateLiteralLoose"));

var _react = _interopRequireWildcard(require("react"));

var _styledComponents = _interopRequireDefault(require("styled-components"));

var _classNames = _interopRequireDefault(require("react-utils/classNames"));

var _UIBox = _interopRequireDefault(require("./UIBox"));

var _UIScrollContainer = _interopRequireDefault(require("../scroll/UIScrollContainer"));

var _refObject = _interopRequireDefault(require("../utils/propTypes/refObject"));

var _ShareScrollElement = _interopRequireDefault(require("../decorators/ShareScrollElement"));

function _templateObject() {
  var data = (0, _taggedTemplateLiteralLoose2.default)(["\n  height: auto;\n"]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

var AutoHeightScrollContainer = (0, _styledComponents.default)(_UIScrollContainer.default.defaultProps.ScrollContainer).withConfig({
  displayName: "UIScrollingColumn__AutoHeightScrollContainer",
  componentId: "sc-15ihrzd-0"
})(_templateObject());

var UIScrollingColumn = _react.default.createClass({
  displayName: "UIScrollingColumn",
  propTypes: {
    children: _react.PropTypes.node,
    flexBasis: _react.PropTypes.oneOfType([_react.PropTypes.number, _react.PropTypes.string]),
    flexGrow: _react.PropTypes.number,
    flexShrink: _react.PropTypes.number,
    footerClassName: _react.PropTypes.string,
    footerContent: _react.PropTypes.node,
    headerClassName: _react.PropTypes.string,
    headerContent: _react.PropTypes.node,
    maxHeight: _react.PropTypes.oneOfType([_react.PropTypes.number, _react.PropTypes.string]),
    Overhang: _UIScrollContainer.default.propTypes.Overhang,
    scrollDirection: _UIScrollContainer.default.propTypes.scrollDirection,
    scrollElementRef: _refObject.default.isRequired
  },
  getDefaultProps: function getDefaultProps() {
    return {
      scrollDirection: 'vertical'
    };
  },

  /**
   * Resets the scroll position of the scrolling content area to the top.
   * @public
   */
  scrollToTop: function scrollToTop() {
    var scrollElementRef = this.props.scrollElementRef;

    if (scrollElementRef.current) {
      scrollElementRef.current.scrollTop = 0;
    }
  },
  renderHeader: function renderHeader(contents, className) {
    if (!contents) return false;
    return _react.default.createElement("header", {
      className: (0, _classNames.default)('private-scroll-columns__header', 'has--vertical-spacing', className)
    }, contents);
  },
  renderFooter: function renderFooter(contents, className) {
    if (!contents) return false;
    return _react.default.createElement("footer", {
      className: (0, _classNames.default)('private-scroll-columns__footer', 'has--vertical-spacing', className)
    }, contents);
  },
  render: function render() {
    var _this$props = this.props,
        className = _this$props.className,
        children = _this$props.children,
        flexBasis = _this$props.flexBasis,
        flexGrow = _this$props.flexGrow,
        flexShrink = _this$props.flexShrink,
        footerClassName = _this$props.footerClassName,
        footerContent = _this$props.footerContent,
        headerClassName = _this$props.headerClassName,
        headerContent = _this$props.headerContent,
        maxHeight = _this$props.maxHeight,
        Overhang = _this$props.Overhang,
        scrollDirection = _this$props.scrollDirection,
        scrollElementRef = _this$props.scrollElementRef,
        rest = (0, _objectWithoutProperties2.default)(_this$props, ["className", "children", "flexBasis", "flexGrow", "flexShrink", "footerClassName", "footerContent", "headerClassName", "headerContent", "maxHeight", "Overhang", "scrollDirection", "scrollElementRef"]);
    return _react.default.createElement(_UIBox.default, (0, _extends2.default)({}, rest, {
      basis: flexBasis,
      className: (0, _classNames.default)('private-scroll-columns__column', className),
      grow: flexGrow,
      shrink: flexShrink
    }), _react.default.createElement("div", {
      className: "private-scroll-columns__inner",
      style: {
        maxHeight: maxHeight
      }
    }, this.renderHeader(headerContent, headerClassName), _react.default.createElement(_UIScrollContainer.default, {
      className: "private-scroll-columns__column--stretch",
      Overhang: Overhang,
      scrollDirection: scrollDirection,
      scrollElementRef: scrollElementRef,
      ScrollContainer: AutoHeightScrollContainer
    }, children), this.renderFooter(footerContent, footerClassName)));
  }
});

var _default = (0, _ShareScrollElement.default)(UIScrollingColumn);

exports.default = _default;
module.exports = exports.default;